import React, {useCallback, useEffect, useRef, useState} from 'react';
import {useParams} from "react-router-dom";
import {API_BASE_URL} from "../config";
import axios from "axios";
import ReactQuill from "react-quill-new";
import {ToastContainer, toast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import BackToTickets from "../components/Ticketing/TicketsTopButtonsBar";
import Button from "../components/Elements/Button";
import CommentsSection from "../components/Ticketing/CommentsSection";
import Loading from "../components/Loading";
import {Tooltip} from 'react-tooltip';
import {formatDateDDMMYYYY} from "../utils/dateUtils";
import Select from "react-select";
import 'react-quill/dist/quill.snow.css';
import 'react-tooltip/dist/react-tooltip.css';
import TicketStatus from "../components/Ticketing/TicketStatus";

const Ticket = () => {
    const {id} = useParams();
    const [toggleHoverPriority, setToggleHoverPriority] = useState(false);
    const [toggleHoverStatus, setToggleHoverStatus] = useState(false);
    const [loading, setLoading] = useState(true);
    const [hoveredUser, setHoveredUser] = useState(null);
    const [ticket, setTicket] = useState({});
    const [description, setDescription] = useState("");
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [assignedUsers, setAssignedUsers] = useState([]);
    const [filteredUsers, setFilteredUsers] = useState([]);
    const [inputValue, setInputValue] = useState("");
    const [assignedUserIds, setAssignedUserIds] = useState([]);
    const [priorityLevels, setPriorityLevels] = useState([]);
    const [priorityLevel, setPriorityLevel] = useState("");
    const [priorityLevelBorderColor, setPriorityLevelBorderColor] = useState("");
    const [lastUpdatedAt, setLastUpdatedAt] = useState("");
    const [statusLevel, setStatusLevel] = useState("");
    const [statusBorderColor, setStatusBorderColor] = useState("");
    const [statusLevels, setStatusLevels] = useState([]);
    const [comment, setComment] = useState("");
    const [comments, setComments] = useState([]);
    const [updates, setUpdates] = useState([]);
    const [ticketTimes, setTicketTimes] = useState([]);
    const [customerTickets, setCustomerTickets] = useState([]);
    const [replyTo, setReplyTo] = useState(null);
    const [totalTimeSpent, setTotalTimeSpent] = useState("00:00");
    const [addTime, setAddTime] = useState(false);
    const [timeSpent, setTimeSpent] = useState('');
    const [creatorEmail, setCreatorEmail] = useState('');
    const [timeComment, setTimeComment] = useState('');
    const [editMode, setEditMode] = useState(false);
    const [customer, setCustomer] = useState(null);
    const [customers, setCustomers] = useState([]);
    const [selectedOption, setSelectedOption] = useState(null);
    const [selectedType, setSelectedType] = useState('');
    const [selectedDepartment, setSelectedDepartment] = useState(null);
    const [ticketTitle, setTicketTitle] = useState("");
    const [ticketDepartment, setTicketDepartment] = useState("");
    const [ticketCustomerEmail, setTicketCustomerEmail] = useState("");
    const [options, setOptions] = useState([]);
    const [optionsTypes, setOptionsTypes] = useState([]);
    const [optionsDepartments, setOptionsDepartments] = useState([]);
    const [dataChanged, setDataChanged] = useState(false);
    const [editorKey, setEditorKey] = useState(Date.now());
    const [attachments, setAttachments] = useState([]);

    const descriptionRef = useRef(null);
    const commentRef = useRef(null);
    const selectionRef = useRef(null);


    const fileHandler = useCallback(() => {
        const forbiddenExt = new Set([".js", ".mjs", ".cjs", ".ts", ".tsx", ".sh", ".bash", ".zsh", ".bat", ".cmd", ".ps1", ".php", ".phtml", ".phar", ".pl", ".py", ".rb", ".jar", ".com", ".exe", ".dll", ".msi", ".scr", ".gadget", ".vb", ".vbs", ".hta", ".wsf", ".apk"]);

        const forbiddenMimePrefixes = ["application/x-msdownload", "application/x-msi", "application/x-dosexec", "application/x-sh", "application/x-bat", "application/x-php", "application/x-python", "text/javascript", "application/javascript", "application/x-javascript", "application/x-ruby",];

        const isForbidden = (file) => {
            const name = file.name.toLowerCase().trim();
            const byExt = Array.from(forbiddenExt).some(ext => name.endsWith(ext));
            const type = (file.type || "").toLowerCase();
            const byMime = forbiddenMimePrefixes.some(p => type.startsWith(p));
            return byExt || byMime;
        };

        const input = document.createElement("input");
        input.type = "file";
        input.multiple = true;
        input.accept = "*/*";

        input.click();

        input.onchange = async () => {
            const files = Array.from(input.files || []);
            if (!files.length) return;

            for (const file of files) {
                const MAX_MB = 20;
                if (file.size > MAX_MB * 1024 * 1024) {
                    console.warn(`File too large: ${file.name}`);
                    continue;
                }

                if (isForbidden(file)) {
                    console.warn(`Blocked dangerous file: ${file.name}`);
                    continue;
                }

                try {

                    // Upload file
                    const formData = new FormData();
                    formData.append("file", file);
                    if (id) formData.append("ticket_id", String(id));

                    const {data} = await axios.post(`${API_BASE_URL}/upload_file`, formData, {headers: {"Content-Type": "multipart/form-data"}});

                    // Expect backend returns something like: { url, name, size, type }
                    const savedName = data?.name || file.name;
                    const savedPath = data?.url || data?.path;

                    axios.post(`${API_BASE_URL}/add_ticket_file`, {
                        id: id,      // ticket id
                        name: savedName,   // file name
                        path: savedPath,   // full URL/path from upload
                    })
                        .then(res => {

                            setAttachments(res.data.attachments)
                        });

                } catch (err) {
                    console.error("File upload failed:", err);
                }
            }
        };
    }, [id]);

    // Effect to restore the selection once the state has updated.
    useEffect(() => {
        if (commentRef.current && typeof commentRef.current.getEditor === "function" && selectionRef.current) {
            setTimeout(() => {
                try {
                    const editor = commentRef.current.getEditor();
                    if (editor && typeof editor.setSelection === "function") {
                        editor.setSelection(selectionRef.current);
                    }
                } catch (err) {
                    console.warn("Editor instance not ready for selection restore", err);
                }
            }, 50); // Adjust the delay if needed.
        }
    }, [comment]);

    // Create a custom Quill modules configuration that uses the provided ref
    const createQuillModules = (quillRef) => ({
        toolbar: {
            container: [[{header: [1, 2, 3, false]}], ["bold", "italic", "underline", "strike"], ["blockquote", "code-block"], ["link", "image"], [{align: []}], [{color: []}, {background: []}], ["clean"],],
            handlers: {
                // Custom image handler for image uploads
                image: async () => {
                    // Create a temporary input element and trigger a file dialog
                    const input = document.createElement("input");
                    input.setAttribute("type", "file");
                    input.setAttribute("accept", "image/*");
                    input.click();

                    input.onchange = async () => {
                        const file = input.files[0];
                        if (file) {
                            const formData = new FormData();
                            formData.append("image", file);

                            try {
                                // Send the image file to your backend upload endpoint
                                const res = await axios.post(`${API_BASE_URL}/upload_image`, formData);
                                // If the backend returns an image URL, insert it into the editor
                                if (res.data && res.data.url) {
                                    const quillEditor = quillRef.current.getEditor();
                                    const range = quillEditor.getSelection();
                                    quillEditor.insertEmbed(range ? range.index : 0, "image", res.data.url);
                                }
                            } catch (error) {
                                console.error("Error uploading image:", error);
                                toast.error("Erreur lors du téléchargement de l'image");
                            }
                        }
                    };
                },
            },
        }, clipboard: {
            matchVisual: false,
        },
    });

    const descriptionQuillModules = createQuillModules(descriptionRef);
    const commentQuillModules = createQuillModules(commentRef);

    useEffect(() => {

        document.title = `Ticket #${id}`;
        setLoading(true);

        axios.post(`${API_BASE_URL}/get_ticket_info`, {id})
            .then(res => {
                const ticketData = res.data[0];
                setTicket(ticketData);
                // console.log("ticketData")
                // console.log(ticketData)
                setAttachments(ticketData.attachments)
                setCustomer(ticketData.customer)
                setPriorityLevel(ticketData.priority_name)
                setPriorityLevelBorderColor(ticketData.priority_color)
                setStatusBorderColor(ticketData.status_color)
                setCreatorEmail(ticketData.creator_email)
                setSelectedType(ticketData.ticket_type)

                if (ticketData.mail) setTicketCustomerEmail(ticketData.mail);
                if (ticketData.customer_email) setTicketCustomerEmail(ticketData.customer_email);
                setStatusLevel(ticketData.status_name || "");
                let descriptionHtml = ticketData.description || '';

                // 1. parse attachments JSON (if any)
                let attachments = [];
                try {
                    attachments = ticketData.attachments ? JSON.parse(ticketData.attachments) : [];
                } catch (e) {
                    console.error('Could not parse attachments JSON', e);
                }

                // 2. parse the HTML into a DOM
                const parser = new DOMParser();
                const doc = parser.parseFromString(descriptionHtml, 'text/html');

                // 3. find all placeholder img[src="//:0"] and replace in order
                const placeholderImgs = doc.querySelectorAll('img[src="//:0"]');
                placeholderImgs.forEach((imgEl, idx) => {
                    const file = attachments[idx];
                    if (file && file.path) {
                        // build your full URL
                        imgEl.src = `https://x.solution-digitale.ch${file.path}`;
                    }
                });

                // 4. serialize back to HTML
                const patchedHtml = doc.body.innerHTML;
                setDescription(patchedHtml);

                setLastUpdatedAt(ticketData.ticket_updated_at || new Date());

                // Handle ticket type
                if (ticketData.ticket_type) {
                    setTicketTitle(ticketData.ticket_type);
                } else {
                    setTicketTitle(ticketData.title)
                }

                // Handle assigned users
                const userIds = typeof ticketData.assigned_user === "string" ? ticketData.assigned_user.split(",").map(id => id.trim()) : [ticketData.assigned_user];
                setAssignedUserIds(userIds);

                // Set ticket department
                if (ticketData.department) {
                    setTicketDepartment(ticketData.department);

                    //console.log("Ticket Found ".ticketData.department); // Fred
                    setSelectedDepartment(ticketData.department); // Fred

                    // Fetch ticket types based on department
                    return axios.post(`${API_BASE_URL}/get_tickets_types`, {
                        department: ticketData.department
                    });
                } else return null;
            })
            .then(res => {
                if (res) {

                    setOptionsTypes(res.data.length > 0 ? res.data.map(type => ({
                        value: type.id, label: type.name,
                    })) : []);
                    // Now that we have all data, we can set the dropdown selections
                    setTimeout(() => {
                        // Set selected department
                        if (ticket.department && optionsDepartments.length > 0) { 
                            const depOption = optionsDepartments.find(opt => String(opt.value) === String(ticket.department));
                            console.log("depOption");
                            console.log(depOption);
                            setSelectedDepartment(depOption.value || null);
                        }

                        // Set selected customer
                        if (ticket.customer_id && options.length > 0) {
                            const clientOption = options.find(opt => String(opt.value) === String(ticket.customer_id));
                            setSelectedOption(clientOption || null);
                        }

                        setLoading(false);
                    }, 1);
                } else {
                    setLoading(false);
                }
            })
            .catch(error => {
                console.error("Error fetching ticket info:", error);
                toast.error("Impossible de charger les informations du ticket");
                setLoading(false);
            });
    }, [id, dataChanged, attachments, ticket.department, ticket.customer_id, optionsDepartments, options]);

// Formats allowed in the editor
    const quillFormats = ['header', 'bold', 'italic', 'underline', 'strike', 'blockquote', 'code-block', 'link', 'image', 'align', 'color', 'background',];

    // Load customers
    useEffect(() => {
        axios.post(`${API_BASE_URL}/get_all_customers_without_no_homes`)
            .then(res => {
                const filteredData = res.data.datas.filter(item => item.url !== '307.solution-digitale.ch' && item.url !== '308.solution-digitale.ch');
                const sortedData = filteredData.sort((a, b) => b.timestamp - a.timestamp);
                setCustomers(sortedData);
                setOptions(sortedData.length > 0 ? sortedData.map(client => ({
                    value: client.id, label: client.name_1,
                })) : [])

            })
            .catch(error => {
                console.error("Error fetching customers:", error);
                toast.error("Impossible de charger les clients");
            });
    }, []);

    // Load departments
    useEffect(() => {
        axios.post(`${API_BASE_URL}/get_all_departments`)
            .then(response => {


                setOptionsDepartments(response.data.length > 0 ? response.data.map(type => ({
                    value: type.id, label: type.name,
                })) : []);

            })
            .catch(error => {
                console.error("Error fetching departments:", error);
                toast.error("Impossible de charger les départements");
            });
    }, []);

    // Load departments
    useEffect(() => {

        axios.post(`${API_BASE_URL}/get_ticket_types`, {department: ticketDepartment})
            .then(response => {

                setOptionsTypes(response.data.datas.length > 0 ? response.data.datas.map(type => ({
                    value: type.id, label: type.name,
                })) : []);
                //setTicket(response.data);
            })
            .catch(error => {
                console.error("Error fetching departments:", error);
                toast.error("Impossible de charger les départements");
            });
    }, [selectedDepartment, ticketDepartment]);

    // Load comments
    useEffect(() => {
        axios.post(`${API_BASE_URL}/get_ticket_comments`, {id})
            .then(res => {
                setComments(res.data);
            })
            .catch(error => {
                console.error("Error fetching comments:", error);
            });

        // Load ticket times
        axios.post(`${API_BASE_URL}/get_ticket_times_spent`, {id})
            .then(res => {
                // Convert time string (HH:MM:SS) to seconds
                const timeStringToSeconds = (timeStr) => {
                    const [hours, minutes, seconds] = timeStr.split(':').map(Number);
                    return hours * 3600 + minutes * 60 + (seconds || 0);
                };

                // Sum all time values in seconds
                const totalSeconds = res.data.reduce((total, record) => {
                    return total + timeStringToSeconds(record.time_spent);
                }, 0);

                // Convert total seconds back to HH:MM format
                const formatSecondsToTime = (seconds) => {
                    const hrs = Math.floor(seconds / 3600);
                    const mins = Math.floor((seconds % 3600) / 60);
                    return `${hrs.toString().padStart(2, '0')}:${mins.toString().padStart(2, '0')}`;
                };

                const totalTimeFormatted = formatSecondsToTime(totalSeconds);
                setTotalTimeSpent(totalTimeFormatted);

                // Remove seconds from each record's time_spent
                const formattedData = res.data.map(record => ({
                    ...record, time_spent: record.time_spent.slice(0, 5) // Slices "HH:MM:SS" to "HH:MM"
                }));

                setTicketTimes(formattedData);
            })
            .catch(error => {
                console.error("Error fetching ticket times:", error);
            });
    }, [id]);


    const triggerComments = () => {
        axios.post(`${API_BASE_URL}/get_ticket_comments`, {id})
            .then(res => {
                setComments(res.data);
            })
            .catch(error => {
                console.error("Error fetching comments:", error);
            });
    }

    // This function is called when the "Envoyer" button is clicked.
    // We obtain the content directly from the editor instance.
    const handleSaveComment = () => {
        if (commentRef.current && typeof commentRef.current.getEditor === "function") {
            const editor = commentRef.current.getEditor();
            const content = editor.root.innerHTML;
            saveComment(content);

            // ✅ Force remount of the editor
            setEditorKey(Date.now());
        }
    };

    // Load priority levels
    useEffect(() => {
        // Charge et actualise la liste de l'historique
        axios.post(`${API_BASE_URL}/get_ticket_updates`, {id})
            .then(res => {
                setUpdates(res.data);
            })
            .catch(error => {
                console.error("Error fetching ticket updates:", error);
            });
    }, [id, priorityLevel, statusLevel]);

    useEffect(() => {

        axios.post(`${API_BASE_URL}/get_priority_levels`, {id})
            .then(res => {
                setPriorityLevels(res.data);
            })
            .catch(error => {
                console.error("Error fetching priority levels:", error);
            });

        axios.post(`${API_BASE_URL}/get_status_levels`, {id})
            .then(res => {
                setStatusLevels(res.data);
            })
            .catch(error => {
                console.error("Error fetching status levels:", error);
            });

    }, [id]);


    // Load customer tickets
    useEffect(() => {
        if (ticket && ticket.customer) {
            const customer_id = ticket.customer;
            axios.post(`${API_BASE_URL}/get_tickets_per_customer`, {customer_id})
                .then(res => {
                    setCustomerTickets(res.data);
                })
                .catch(error => {
                    console.error("Error fetching customer tickets:", error);
                });
        }
    }, [ticket]);

    // Load assigned users
    useEffect(() => {
        // Ensure `userIds` is always an array
        let userIds = Array.isArray(assignedUserIds) ? assignedUserIds : typeof assignedUserIds === 'string' ? assignedUserIds.split(',').map(id => id.trim()) : [assignedUserIds];

        if (userIds.length > 0 && userIds[0]) {
            // Fetch usernames for the IDs
            axios.post(`${API_BASE_URL}/get_user_name`, {ids: userIds})
                .then(userRes => {
                    setAssignedUsers(userRes.data.usernames);
                })
                .catch(error => {
                    console.error("Error fetching usernames:", error);
                });
        }
    }, [assignedUserIds]);

    // Handle user input changes
    const handleInputChange = (e) => {
        const value = e.target.value;
        setInputValue(value);
        fetchUsers(value);
    };

    // Handle key press in input
    const handleKeyDown = (e) => {
        if (e.key === "Enter" && inputValue) {
            saveTicket(inputValue);
        }
    };

    // Delete assigned user
    const deleteAssignedUser = (username) => {
        axios.post(`${API_BASE_URL}/delete_ticket_assigned_user`, {id, username})
            .then(res => {
                setLastUpdatedAt(Date.now());
                setAssignedUserIds(res.data.assigned_user);
                toast.success("Utilisateur retiré avec succès");
            })
            .catch(error => {
                console.error("Error removing user:", error);
                toast.error("Impossible de retirer l'utilisateur");
            });
    };

    // Save ticket with new assigned user
    const saveTicket = (username) => {

        if (ticket.department !== "0" && ticket.ticket_type !== null && (ticket.name_1 !== null || ticket.name_2 !== null)) {
            axios.post(`${API_BASE_URL}/save_ticket_info`, {
                id, usernames_assigned: username, attachments: attachments
            })
                .then(res => {
                    // Parse the response to update assigned user IDs
                    const assignedIdUsersArray = typeof res.data.rows[0].assigned_user === "string" ? res.data.rows[0].assigned_user.split(",").map(id => id.trim()) : [res.data.rows[0].assigned_user];

                    setLastUpdatedAt(Date.now());
                    setAssignedUserIds(assignedIdUsersArray);
                    setIsModalOpen(false);
                    setInputValue("");
                    toast.success("Utilisateur ajouté avec succès");
                })
                .catch(error => {
                    console.error("Error saving ticket:", error);
                    toast.error("Impossible d'ajouter l'utilisateur");
                });
        } else {
            toast.error("Il faut remplir toutes les informations client avant de pouvoir assigner le ticket à quelqu'un");
        }
    };

    // Show add user modal
    const showAddUserModal = () => {
        setIsModalOpen(true);
        fetchUsers("");
    };

    // Fetch users
    const fetchUsers = async (query = "") => {
        try {
            const res = await axios.post(`${API_BASE_URL}/get_users`);

            // Filter users based on the query
            const filtered = res.data.filter(user => user.username_display.toLowerCase().includes(query.toLowerCase()));
            setFilteredUsers(filtered);
        } catch (error) {
            console.error("Error fetching users:", error);
        }
    };

    // Change priority level
    const changePriorityLevel = (priority) => {
        // console.log("priority")
        // console.log(priority)
        setToggleHoverPriority(false);
        const user_id = localStorage.getItem("user_id");

        axios.post(`${API_BASE_URL}/update_ticket_priority_level`, {
            id, priorityLevel: priority.id, user_id
        })
            .then(res => {
                setPriorityLevel(res.data[0].name);
                setPriorityLevelBorderColor(priority.color)
                setLastUpdatedAt(Date.now());
                toast.success("Priorité mise à jour avec succès");
            })
            .catch(error => {
                console.error("Error updating priority:", error);
                toast.error("Impossible de mettre à jour la priorité");
            });
    };

    // Change status
    const changeStatus = (status) => {
        setToggleHoverStatus(false);
        const user_id = localStorage.getItem("user_id");

        axios.post(`${API_BASE_URL}/update_ticket_status`, {
            id, status, user_id
        })
            .then(res => {
                setStatusLevel(res.data[0].name);
                setStatusBorderColor(res.data[0].color)
                setLastUpdatedAt(Date.now());
                toast.success("Statut mis à jour avec succès");
            })
            .catch(error => {
                console.error("Error updating status:", error);
                toast.error("Impossible de mettre à jour le statut");
            });
    };

    // Save comment
    const saveComment = (comment) => {
        if (!comment) {
            toast.error("Le commentaire ne peut pas être vide");
            return;
        }

        const user_id = localStorage.getItem("user_id");

        axios.post(`${API_BASE_URL}/save_comment_ticket`, {
            id, user: user_id, comment, reply_to: replyTo
        })
            .then(res => {
                setComments(res.data);
                setComment("");
                setReplyTo(null);
                toast.success("Commentaire ajouté avec succès");
            })
            .catch(error => {
                console.error("Error saving comment:", error);
                toast.error("Impossible d'ajouter le commentaire");
            });
    };

    const triggerAssignedUsers = () => {

        // Ensure `userIds` is always an array
        let userIds = Array.isArray(assignedUserIds) ? assignedUserIds : typeof assignedUserIds === 'string' ? assignedUserIds.split(',').map(id => id.trim()) : [assignedUserIds];

        if (userIds.length > 0 && userIds[0]) {
            // Fetch usernames for the IDs
            axios.post(`${API_BASE_URL}/get_user_name`, {ids: userIds})
                .then(userRes => {
                    setAssignedUsers(userRes.data.usernames);
                })
                .catch(error => {
                    console.error("Error fetching usernames:", error);
                });
        }
    }

    // Toggle add time form
    const toggleAddTime = () => {
        setAddTime(prev => !prev);
    };

    // Handle time form submission
    const handleSubmit = (e) => {
        e.preventDefault();

        if (!timeSpent) {
            toast.error("La durée ne peut pas être vide");
            return;
        }

        const user_id = localStorage.getItem("user_id");

        axios.post(`${API_BASE_URL}/add_time_spent`, {
            id, time_spent: timeSpent, user_id, comment: timeComment,
        })
            .then(res => {
                setTicketTimes(res.data);
                setTimeSpent('');
                setTimeComment('');
                setAddTime(false);
                toast.success("Temps ajouté avec succès");
            })
            .catch(error => {
                console.error('Error logging time:', error);
                toast.error("Impossible d'ajouter le temps");
            });
    };

    // Handle reply to comment
    const handleReply = (comment) => {
        setReplyTo(comment.id);
        setComment("");
    };


    // Toggle edit mode
    const toggleParentEditMode = () => {
        setEditMode(prev => !prev);
    };


    // Update selected options whenever dropdown data changes
    useEffect(() => {
        const depOption = optionsDepartments.find(opt => String(opt.value) === String(ticket.department));
        //console.log("optionsDepartments")
        //console.log(optionsDepartments)
        //setSelectedDepartment(depOption || null);
        const typeOption = optionsTypes.find(opt => String(opt.value) === String(ticket.ticket_type_id));
        setSelectedType(typeOption || null);
        const clientOption = options.find(opt => String(opt.value) === String(ticket.customer_id));
        setSelectedOption(clientOption || null);

    }, [id, editMode, optionsDepartments, optionsTypes, options, ticket.department, ticket.ticket_type_id, ticket.customer_id]);

    const saveTicketInfo = () => {console.log("SAVING");
    // console.log(selectedDepartment);
        const data = [{
            // Either use optional chaining or standard conditional checks
            title: ticketTitle || "",
            customer: customer || "",
            description: description || "",
            customer_email: (selectedType && selectedType.label !== "Interne") ? ticketCustomerEmail : creatorEmail || "",
            // department: (selectedDepartment && selectedDepartment.value) ? selectedDepartment.value : "",
            department: (selectedDepartment) ? selectedDepartment : "",
            ticket_type: (selectedType && selectedType.value) ? selectedType.value : "",
        }];

        axios.post(`${API_BASE_URL}/update_ticket`, {id, data})
            .then(res => {
                setEditMode(false);
                setLastUpdatedAt(Date.now());
                setDataChanged((prev) => !prev);
                toast.success("Ticket mis à jour avec succès");
            })
            .catch(error => {
                console.error("Error updating ticket:", error);
                toast.error("Impossible de mettre à jour le ticket");
            });
    };


    if (loading) {
        return (<div className="min-h-screen flex items-center justify-center">
            <Loading/>
        </div>);
    }

    return (<div className="ticket-page">
        <ToastContainer position="bottom-right" autoClose={3000}/>
        <div className="ticket-content">
            <div className="ticket-main">
                <div className="container-back-ticket">
                    {ticket ? <BackToTickets
                        ticket={ticket}
                        toggleParentEditMode={toggleParentEditMode}
                        saveTicketInfo={saveTicketInfo}
                    /> : <Loading/>}
                </div>
                <div className="p-20 display-flex flex-direction-column">
                    <div>
                        <div className="display-flex flex-direction-column ">
                            <span
                                class={"ticket-number-container display-flex gap-10 align-items-center mb-20 color-third"}>
                            <i className={"fa-regular fa-ticket"}/>
                                <div className={"v-separator"} style={{
                                    backgroundColor: 'rgb(222,222,222', width: 2, height: "-webkit-fill-available"
                                }}/>
                            <h3 className={"color-third"}>TICKET N° {ticket.ticket_id}</h3>
                            </span>
                            {editMode ? (<>
                                <div className={"display-flex justify-content-space-between gap-20"}>
                                    <span className="ticket-title">{ticketTitle}</span>
                                    <div className={"display-flex gap-20 align-items-flex-start mb-20"}>
                                        <Button onClick={() => setEditMode(false)} icon={"fa-xmark"}
                                                label={"Annuler"} textClassNames={"bg-orangered"}
                                                iconBackground={'bg-warning text-white'} disableLink/>
                                        <Button onClick={saveTicketInfo} icon={"fa-floppy-disk"}
                                                label={"Enregistrer"}
                                                textClassNames={"bg-third text-white btn-save"}
                                                iconBackground={'bg-fifth'} disableLink/>
                                    </div>
                                </div>
                                <div className="display-flex gap-20 mb-20">
                                    <div className={"display-flex flex-direction-column flex-1"}>
                                        <span className={"mb-10"}>Département</span>
                                        <Select
                                            noOptionsMessage={() => 'Aucun résultat trouvé'}
                                            value={ticketDepartment ? optionsDepartments[ticketDepartment] : optionsDepartments[selectedDepartment]}
                                            placeholder="Département"
                                            options={optionsDepartments}
                                            onChange={(option) => {
                                                setSelectedDepartment(option ? option.value : null);
                                                setTicketDepartment(option ? option.value : null);
                                            }}
                                            isClearable={true}
                                            styles={{
                                                container: (provided) => ({
                                                    ...provided, width: "100%", position: "relative"
                                                }), control: (provided) => ({
                                                    ...provided,
                                                    width: "100%",
                                                    textAlign: "left",
                                                    height: "51px",
                                                    borderRadius: 8,
                                                    paddingLeft: "10px"
                                                }),
                                            }}
                                        /></div>
                                    <>
                                        <div className={"display-flex flex-direction-column flex-1"}>
                                            <span className={"mb-10"}>Type de ticket</span>
                                            <Select
                                                noOptionsMessage={() => 'Aucun résultat trouvé'}
                                                value={selectedType}
                                                placeholder="Type de ticket"
                                                options={optionsTypes}
                                                onChange={(option) => {
                                                    setSelectedType(option);
                                                    setTicketTitle(option ? option.label : null);
                                                }}
                                                isClearable={true}
                                                styles={{
                                                    container: (provided) => ({
                                                        ...provided, width: "100%", position: "relative"
                                                    }), control: (provided) => ({
                                                        ...provided,
                                                        width: "100%",
                                                        textAlign: "left",
                                                        height: "51px",
                                                        borderRadius: 8,
                                                        paddingLeft: "10px"
                                                    }),
                                                }}
                                            />
                                        </div>
                                    </>
                                </div>
                            </>) : (<span className="ticket-title">{ticketTitle}</span>)}

                            {editMode ? (<>
                                <div className="display-flex flex-direction-column">
                                    <span className="mb-10">Email</span>
                                    {selectedType && ((selectedType.label !== "Interne") ? (<input

                                        onChange={e => setTicketCustomerEmail(e.target.value)}
                                        className="ticket-title input"
                                        style={{
                                            borderRadius: 8,
                                            fontWeight: 1,
                                            fontSize: "1rem",
                                            padding: "15px 0 15px 18px",
                                        }}
                                        value={ticketCustomerEmail}
                                    />) : (<input
                                        disabled={true}
                                        className="ticket-title input disabled"
                                        style={{
                                            backgroundColor: "#ddd",
                                            borderRadius: 8,
                                            fontWeight: 1,
                                            fontSize: "1rem",
                                            padding: "15px 0 15px 18px",
                                        }}
                                        value={creatorEmail}
                                    />))

                                    }

                                </div>
                            </>) : (ticketCustomerEmail && (<h3 className="ticket-title">
                                De : {ticketCustomerEmail}
                            </h3>))}


                            {editMode && (<div className={"display-flex flex-direction-column"}>
                                <span className={"mb-10"}>Entreprise</span>
                                <Select
                                    className="mb-20"
                                    placeholder="Client"
                                    noOptionsMessage={() => 'Aucun résultat trouvé'}
                                    options={options}
                                    value={selectedOption}
                                    onChange={(option) => {
                                        if (!option) {
                                            setSelectedOption(null);
                                        } else {
                                            const selectedCustomer = customers.find(client => client.id === option.value);
                                            setSelectedOption({
                                                value: selectedCustomer.id, label: selectedCustomer.name_1
                                            });
                                            setCustomer(selectedCustomer);
                                        }
                                    }}
                                    isClearable
                                    styles={{
                                        container: (provided) => ({
                                            ...provided, width: "100%", position: "relative"
                                        }), control: (provided) => ({
                                            ...provided,
                                            width: "100%",
                                            textAlign: "left",
                                            height: "51px",
                                            borderRadius: 8,
                                            paddingLeft: "10px"
                                        }),
                                    }}
                                />
                            </div>)}
                        </div>

                        <div className="ticket-description">
                            <ReactQuill
                                ref={descriptionRef}
                                theme="snow"
                                value={description}
                                onChange={content => setDescription(content)}
                                modules={descriptionQuillModules}
                                formats={quillFormats}
                                readOnly={!editMode}
                            />
                        </div>

                        {attachments && attachments !== "[]" && <div key={attachments.length}>
                            <div className="ticket-resolution-notes">
                                <h2 className={"mb-20"}>Pièces jointes</h2>
                            </div>
                            <div className={"display-flex flex-direction-column bg-eee border-radius-10 p-20 "}
                                 style={{overflowX: "scroll"}}>
                                <div className={"display-flex gap-20 flex-direction-row attachments-scrollbar"}
                                     style={{width: "max-content"}}>
                                    {attachments && JSON.parse(attachments).map((file, idx) => {

                                        const ext_raw = file.name.split('.').pop();
                                        const ext = ext_raw.toLowerCase()

                                        let file_ext = 'file';
                                        (ext.toLowerCase() === 'doc' || ext === 'docx') && (file_ext = 'word');
                                        (ext.toLowerCase() === 'png' || ext === 'jpg' || ext === 'jpeg' || ext === 'heic') && (file_ext = 'image');
                                        (ext === 'xls' || ext === 'xlsx' || ext === 'xlsm' || ext === 'csv') && (file_ext = 'excel');
                                        (ext === 'pdf') && (file_ext = 'pdf');
                                        (ext === 'txt') && (file_ext = 'txt');
                                        
                                        // console.log('file_ext')
                                        // console.log(file_ext)

                                        const lastSlashIndex = file.path.lastIndexOf('/');
                                        const basePath = file.path.substring(0, lastSlashIndex + 1);
                                        const fileName = file.path.substring(lastSlashIndex + 1);
                                        const encodedFileName = encodeURIComponent(fileName);
                                        const encodedFilePath = `${basePath}${encodedFileName}`;
                                        return (<div className={"display-flex flex-direction-column p-15"} style={{
                                            maxWidth: 150,
                                            backgroundColor: "rgb(254 253 253)",
                                            borderRadius: 10,
                                            border: "solid 2px #dedede"
                                        }} key={idx}>
                                            <div
                                                style={{width: "100%"}}>

                                                <a href={`https://x.solution-digitale.ch${encodedFilePath}`}
                                                   target="_blank"
                                                   rel="noopener noreferrer"
                                                   download
                                                   className={"display-flex justify-content-center align-items-center flex-direction-column gap-10"}
                                                >
                                                    <span>
                                                        <img
                                                            src={`https://x.solution-digitale.ch/assets/img-${file_ext}.png`}
                                                            width={50}
                                                            alt={'Picto du type d\'extension'}
                                                        />
                                                    </span>

                                                    <div style={{
                                                        height: '2px', width: '100%', backgroundColor: '#eee'
                                                    }}></div>

                                                    {file.name.length > 10 ? file.name.slice(0, 10) + '...' : file.name}
                                                </a>
                                            </div>

                                        </div>)
                                    })}
                                </div>
                            </div>
                        </div>


                        }
                    </div>

                    <div className={"mt-20"} style={{marginBottom: 50}}>
                        <span className="back-button p-10 bg-primary color-white cursor-pointer" onClick={fileHandler}>
                            <i className="fa-regular fa-paperclip mr-10"/> Ajouter des pièces jointes
                        </span>
                    </div>

                    <div className="ticket-resolution-notes">
                        {comments.length > 0 && (<>
                            <h2 className={"mb-20"}>Commentaires</h2>
                            <div style={{paddingBottom: 30, display: "flex", flexDirection: "column"}}>
                                <CommentsSection
                                    comments={comments}
                                    onReply={handleReply}
                                    replyTo={replyTo}
                                    comment={comment}
                                    setComment={setComment}
                                    newCommentTrigger={triggerComments}
                                    saveComment={saveComment}
                                    triggerAssignedUsers={triggerAssignedUsers}
                                />
                                <div className="separator"/>
                            </div>
                        </>)}

                        <span className="my-20">
                            <h2>Nouveau commentaire...</h2>
                        </span>


                        <ReactQuill
                            key={editorKey} // 🔁 Changing this forces a reset
                            ref={commentRef}
                            defaultValue=""
                            readOnly={false}
                            style={{minHeight: 200}}
                            modules={commentQuillModules}
                            formats={quillFormats}
                            theme="snow"
                        />

                        <button
                            style={{zIndex: 9, marginLeft: 0}}
                            className="mt-0 button-third"
                            onClick={handleSaveComment}
                        >
                            Envoyer
                        </button>

                    </div>
                </div>
            </div>

            <div className="ticket-meta">
                <div className="p-20 ticket-details display-flex flex-direction-column">
                    <span className="mb-20">
                      <strong className="title-ticket">Détails</strong>
                    </span>
                    <div className="display-flex gap-10">
                        <div
                            className="flex-1"
                            style={{position: "relative"}}
                            onMouseEnter={() => setToggleHoverPriority(true)}
                            onMouseLeave={() => setToggleHoverPriority(false)}
                        >
                          <span
                              style={{
                                  backgroundColor: priorityLevel,
                                  border: `solid 3px ${priorityLevelBorderColor ? priorityLevelBorderColor : "#000"}`,
                                  transition: "all 0.3s ease",
                              }}
                              className="priority-ticket ticket-status"
                          >
                            <strong>{priorityLevel}</strong>
                          </span>

                            {toggleHoverPriority && (<div
                                className="ticket-status-child display-flex"
                            >
                                {priorityLevels.map((priority) => (<span
                                    key={priority.id}
                                    style={{
                                        border: `solid 3px ${priority.color}`,
                                        backgroundColor: `${priority.color}`,
                                        transition: "all 0.3s ease",
                                    }}
                                    className="priority-ticket ticket-status crop-text"
                                    onClick={() => changePriorityLevel(priority)}
                                >
                                              {priority.name}
                                            </span>))}
                            </div>)}
                        </div>

                        <div
                            className="flex-1"
                            style={{position: "relative"}}  // <-- Add this
                            onMouseEnter={() => setToggleHoverStatus(true)}
                            onMouseLeave={() => setToggleHoverStatus(false)}
                        >
                            <span className="priority-ticket ticket-status crop-text"
                                  style={{
                                      border: `solid 3px ${statusBorderColor ? statusBorderColor : '#fff'}`,
                                      transition: "all 0.3s ease",
                                  }}>
                            <strong>{statusLevel}</strong>
                            </span>

                            {toggleHoverStatus && (<div className="ticket-status-child display-flex">
                                {statusLevels.map((status) => (<span
                                    key={status.id}
                                    style={{
                                        border: `solid 3px ${status.color}`,
                                        backgroundColor: `${status.color}`,
                                        color: `${status.text_color}`,
                                        transition: "background-color 0.3s ease, transform 0.2s ease",
                                    }}
                                    className={`priority-ticket ticket-status crop-text ticket-${status.color}`}
                                    onClick={() => changeStatus(status.id)}
                                >
                                    {status.name}
                                    </span>))}
                            </div>)}
                        </div>

                    </div>

                    <p className="mt-15">{ticket && ticket.created_at ? (<span>
                        
                            Ouvert le {new Date(ticket.created_at).toLocaleString()} par{" "}
                        <strong>{ticket.created_username}</strong>
                        </span>) : (<Loading/>)}

                    </p>
                </div>

                {/* Assigned persons section */}
                <div>
                    <div className="p-20 ticket-details display-flex flex-direction-column">
                        <span className="mb-20">
                            <strong className="title-ticket">Personne(s) assignée(s)</strong>
                        </span>
                        <div className="display-grid">
                            <span className="ticket-icon-people-container pt-0 mt-0"
                                  onMouseLeave={() => setHoveredUser(null)}>
                                {assignedUsers.map((username_display, index) => (
                                    <span key={index} className="ticket-icon-people"
                                          onMouseEnter={() => setHoveredUser(username_display)}>
                                    {username_display}
                                        {hoveredUser === username_display && (<span
                                            className="delete-user-icon display-flex align-center-center justify-content-center"
                                            onClick={() => deleteAssignedUser(username_display)}
                                            style={{cursor: "pointer", marginLeft: "10px", height: 20, width: 20}}>
                                      <i className="fa-solid fa-xmark"></i>
                                    </span>)}
                                </span>))}
                                {assignedUsers.length < 5 && (<span
                                    className="add-user-icon ticket-icon-people"
                                    onClick={showAddUserModal}
                                    style={{cursor: "pointer", fontSize: 10}}
                                >
                                    <i className="fa-solid fa-plus"></i>
                                </span>)}
                            </span>

                            {isModalOpen && (<div style={{marginBottom: "20px"}}>
                                <input
                                    autoFocus
                                    type="text"
                                    className="no-outline border-bottom-1px-third"
                                    placeholder="Ajouter..."
                                    value={inputValue}
                                    onChange={handleInputChange}
                                    onKeyDown={handleKeyDown}
                                    style={{padding: "5px", fontSize: "14px"}}
                                />
                                <ul style={{
                                    marginTop: 5, paddingLeft: 0, listStyleType: "none"
                                }}>
                                    {filteredUsers.map((user, index) => (<li
                                        className="mb-5"
                                        key={index}
                                        onClick={() => saveTicket(user.username_display)}
                                        style={{cursor: "pointer", padding: "5px"}}
                                    >
                          <span className="ticket-icon-people add-ticket-icon-people">
                            {user.username_display}
                          </span>
                                    </li>))}
                                </ul>
                            </div>)}
                        </div>

                        <div className="display-flex gap-5" style={{fontSize: 14}}>
                            <strong>Dernière mise à jour:</strong>{" "}
                            {(new Date(lastUpdatedAt).toLocaleString())}

                        </div>
                    </div>
                </div>

                {/* Time tracking section */}
                <div className="p-20 ticket-details">
                    <div className="display-flex flex-direction-column">
              <span className="mb-20">
                <strong className="title-ticket">Temps</strong>
              </span>
                        {ticketTimes.length > 0 && (<div className="mt-10 mb-10">
                            {ticketTimes.map((time) => (<span
                                key={time.id}
                                className="ticket-status-historic-span display-flex justify-content-space-between align-items-baseline search-item-found flex-direction-row"
                            >
                      <span style={{width: "60%"}}>
                        <span className="p-5-10 display-flex justify-content-center flex-2 crop-text">
                          <span id={`anchor-${time.id}`}>{time.comment}</span>
                          <Tooltip anchorSelect={`#anchor-${time.id}`} place="left">
                            {time.comment}
                          </Tooltip>
                        </span>
                      </span>
                      <div
                          style={{width: "40%"}}
                          className="flex-direction-row display-flex flex-direction-row-reverse justify-content-end"
                      >
                        <span
                            className="ticket-status-historic-span display-flex justify-content-space-between align-items-baseline">
                          <strong className="p-5-10 display-flex justify-content-center flex-2">
                            {time.time_spent}
                          </strong>
                        </span>
                        <span
                            className="ticket-status-historic-span display-flex justify-content-space-between align-items-baseline">
                          <strong className="p-5-10 display-flex justify-content-center flex-2">
                            {time.user}
                          </strong>
                        </span>
                      </div>
                    </span>))}
                        </div>)}

                        <span
                            onClick={toggleAddTime}
                            className="add-time-ticket add-user-icon ticket-icon-people display-flex"
                            style={{cursor: "pointer", height: 30, width: "fit-content"}}
                        >
                <span className="display-flex align-items-baseline gap-10 p-10">
                  {addTime ? (<span>Annuler</span>) : (<>
                      <i className="fa-solid fa-plus"></i>
                      <span>Ajouter du temps</span>
                  </>)}
                </span>
              </span>
                    </div>
                    <div className="add-time-container">
                        {addTime && (<form className="time-spent-form" onSubmit={handleSubmit}>
                            <div className="form-group">
                                <label htmlFor="time_spent" className="">
                                    Durée
                                </label>
                                <input
                                    type="time"
                                    id="time_spent"
                                    value={timeSpent}
                                    onChange={(e) => setTimeSpent(e.target.value)}
                                    required
                                />
                            </div>

                            <div className="form-group">
                                <label htmlFor="comment">Commentaire</label>
                                <textarea
                                    id="comment"
                                    placeholder="Travail réalisé..."
                                    value={timeComment}
                                    onChange={(e) => setTimeComment(e.target.value)}
                                />
                            </div>

                            <button onClick={handleSubmit} className="submit-btn mx-0">
                                Enregistrer
                            </button>
                        </form>)}
                    </div>
                    {ticketTimes.length > 0 && (
                        <div className="separator mt-10" style={{backgroundColor: "#ccc"}}></div>)}

                    <div className="p-20 text-right display-flex justify-content-space-between pb-0">
                        <strong>Total</strong>
                        <strong>{totalTimeSpent}</strong>
                    </div>
                </div>

                {updates.length > 0 &&

                    <div className="p-20 ticket-details">
                        <div className="display-flex flex-direction-column">
              <span className="mb-20">
                <strong className="title-ticket">Historique</strong>
              </span>
                            <div className="gap-10 display-flex flex-direction-column">
                                {updates.map((update) => (<span
                                    key={update.id}
                                    className="ticket-status-historic-container display-flex gap-10 flexwrap-wrap justify-content-space-between align-items-center mb-10 flex-direction-column align-items-flex-start"
                                >
                        <TicketStatus update={update}/>

                    <span className="flex-1" style={{fontSize: ".8rem"}}>
                      Le{" "}

                        <strong>{new Date(update.date).toLocaleString()} </strong>
                        par <strong>{update.updated_by}</strong>
                    </span>
                  </span>))}
                            </div>
                        </div>
                    </div>}

                {/* Customer tickets section */}
                <div className="p-20">
                    <div className="display-flex flex-direction-column">
                        {(ticket && ticket.name_1) && <>
              <span className="mb-20">
                <strong className="title-ticket">
                  Tickets de {ticket && ticket.name_1}
                </strong>
              </span>

                            <div
                                className="display-flex flexwrap-wrap justify-content-space-between align-items-baseline flex-direction-column">
                                {customerTickets.map((customerTicket) => (<a
                                    style={{backgroundColor: parseInt(id) === parseInt(customerTicket.id) ? '#add8e657' : ''}}
                                    key={customerTicket.id}
                                    className="text-decoration-none w-100 border-radius-5"
                                    href={`/ticket/${customerTicket.id}`}
                                >
                                <div className="p-5-10 display-flex justify-content-space-between align-items-baseline gap-20 flex-direction-row ticket-status-historic-container w-100">
                                <div className="display-flex gap-10 align-items-center">
                                    <div className={"display-flex gap-10"}>
                                <div className={"display-flex align-items-center gap-10 p-5-10"}
                                     style={{borderRadius: 20, border: "solid 2px #dedede"}}>
                                <i className={"fa-regular fa-ticket"}/>
                                <strong className={"color-third mb-0"} style={{fontSize: ".75rem"}}>{customerTicket.id}</strong>
                                </div>

                                    <span
                                        className="ticket-status ticket-span-alias p-5-10 bg-color-admin crop-text display-flex flex-direction-column"
                                        style={{backgroundColor: "#66c4c6"}}
                                    >

                                {formatDateDDMMYYYY(customerTicket.created_at)}
                                </span>

                                <span
                                    style={{
                                        minWidth: 80, backgroundColor: customerTicket.ticket_status_bg_color, color: customerTicket.ticket_status_color
                                    }}
                                    className="ticket-status ticket-span-alias p-5-10 display-flex flex-direction-column"
                                >{customerTicket.ticket_status_name}
                                </span>
                                    </div>
                                    <div className="display-flex flex-direction-column">
                                        <span
                                            className="ticket-status-historic-span flex-2 display-flex justify-content-space-between align-items-baseline"
                                        >
                                <strong className="crop-text">
                                {customerTicket.title !== null ? customerTicket.title : customerTicket.ticket_type_name}
                                </strong>
                                </span>
                                    </div>

                                </div>

                                </div>
                                    </a>))}
                            </div>
                        </>}
                    </div>
                </div>
            </div>
        </div>
    </div>);
};

export default Ticket;